import styled from 'styled-components'

export const FormBoxWrapper = styled.div`
  width: 100%;

  @media (min-width: 1024px) {
    &.reset-password-screen {
      max-width: 440px;
    }
  }
`

export const FormBoxStack = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.reset-password-screen {
    box-shadow: 0px 0px 20px 3px #7879f133;
    background: #ffffff;
    border-radius: 5px;

    @media (max-width: 1024px) {
      padding: 20px;
    }
  }

  @media only screen and (max-width: 1023px) {
    :has(#Loading) {
      min-height: 60vh;
    }
  }

  @media (min-width: 1024px) {
    &.reset-password-screen {
      width: 440px;
      height: 500px;
      margin-top: 65px;
      padding-top: 5px;
    }
  }
`

export const FormBoxContainer = styled.div`
  width: 100%;
  padding: 0;
  font-size: 16px;
  border-radius: 5px;

  @media (min-width: 1024px) {
    max-width: 438px;
    width: 100%;

    &.reset-password-screen {
      max-width: 378px;
    }
  }

  @media (max-width: 768px) {
    margin: 0 2rem;
  }

  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--dark);
  }

  h2 {
    font-weight: 400;
    font-size: 14px;
    color: var(--grey3);
    margin-top: 0.25rem;
  }

  button {
    padding: 0;
    width: 100%;
    max-width: 100%;
    height: 50px;
  }

  .title {
    margin-bottom: 2rem;
  }

  .account {
    border-top: 1px solid var(--grey4);
    padding-top: 1.5rem;
  }

  .account > a {
    color: var(--hover);
    font-weight: 500;
    margin-left: 0.5rem;
  }

  @media only screen and (max-width: 1023px) {
    //MOBILE
    min-width: 0;
    width: 100%;
    max-width: 438px;
    margin: 1rem;

    :has(#finalize) {
      height: 100%;
    }

    :has(#Loading) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }

    h1 {
      font-size: 20px;
    }

    h2 {
      margin-top: 1rem;
    }

    input,
    .flexbox > label {
      font-size: 14px;
    }

    input[type='checkbox'] {
      width: 25px;
    }
  }
`

export const FormBoxBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
  margin: 0 0 1rem;
  padding: 0;
  background: none;
  border: none;
  color: var(--grey2);
  font-size: 16px;

  .material-icons {
    font-size: 20px;
  }
`
